/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var expectedPrincipalByWeekColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name'
}, {
  name: 'Офис',
  value: 'office_name',
  sm: true
}, {
  name: 'Обща главница',
  render: function render(_ref) {
    var total_principal = _ref.total_principal,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_principal"
    }, total_principal, " ", currency);
  }
}, {
  name: 'Седм. 1',
  render: function render(_ref2) {
    var weeks = _ref2.weeks,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "weeks.week1"
    }, weeks === null || weeks === void 0 ? void 0 : weeks.week1, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Седм. 2',
  render: function render(_ref3) {
    var weeks = _ref3.weeks,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "weeks.week2"
    }, weeks === null || weeks === void 0 ? void 0 : weeks.week2, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Седм. 3',
  render: function render(_ref4) {
    var weeks = _ref4.weeks,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "weeks.week3"
    }, weeks === null || weeks === void 0 ? void 0 : weeks.week3, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Седм. 4',
  render: function render(_ref5) {
    var weeks = _ref5.weeks,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "weeks.week4"
    }, weeks === null || weeks === void 0 ? void 0 : weeks.week4, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Седм. 5',
  render: function render(_ref6) {
    var weeks = _ref6.weeks,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "weeks.week5"
    }, weeks === null || weeks === void 0 ? void 0 : weeks.week5, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Седм. 6',
  render: function render(_ref7) {
    var weeks = _ref7.weeks,
        currency = _ref7.currency;
    return ___EmotionJSX("span", {
      "data-value": "weeks.week6"
    }, weeks === null || weeks === void 0 ? void 0 : weeks.week6, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Седм. 7',
  render: function render(_ref8) {
    var weeks = _ref8.weeks,
        currency = _ref8.currency;
    return ___EmotionJSX("span", {
      "data-value": "weeks.week7"
    }, weeks === null || weeks === void 0 ? void 0 : weeks.week7, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Седм. 8',
  render: function render(_ref9) {
    var weeks = _ref9.weeks,
        currency = _ref9.currency;
    return ___EmotionJSX("span", {
      "data-value": "weeks.week8"
    }, weeks === null || weeks === void 0 ? void 0 : weeks.week8, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Седм. 9',
  render: function render(_ref10) {
    var weeks = _ref10.weeks,
        currency = _ref10.currency;
    return ___EmotionJSX("span", {
      "data-value": "weeks.week9"
    }, weeks === null || weeks === void 0 ? void 0 : weeks.week9, " ", currency);
  },
  invisibleBelow: 3000
}, {
  name: 'Седм. 10',
  render: function render(_ref11) {
    var weeks = _ref11.weeks,
        currency = _ref11.currency;
    return ___EmotionJSX("span", {
      "data-value": "weeks.week10"
    }, weeks === null || weeks === void 0 ? void 0 : weeks.week10, " ", currency);
  },
  invisibleBelow: 3000
}];